import React, { useContext } from 'react';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import {
  DetailActionButton,
  DetailContext,
  DetailMode,
  DetailToolbarButton2,
  DetailToolbarButtonType,
} from '@eas/common-web';
import { GenerateLicenceDto } from '@models';
import { AuditingEntityType } from '@enums';
import { useGenerateNextDialog } from './dialog-actions/generate-next-hook';

export function Toolbar() {
  const { mode } = useContext(DetailContext);

  const { showGenerateNextBtn, ...generateNextProps } = useGenerateNextDialog();

  return (
    <>
      {showGenerateNextBtn && (
        <DetailActionButton
          promptKey="GENERATE_NEXT"
          dialogTitle="Náhľad generovanej licencie"
          buttonLabel="Generovať"
          dialogText="Prajete si generovať nasledujúcu licenciu?"
          dialogDisableBackdrop
          ButtonComponent={(props) => (
            <DetailToolbarButton2
              {...props}
              disabled={![DetailMode.NONE, DetailMode.VIEW].includes(mode)}
              startIcon={<AddBoxOutlinedIcon />}
              type={DetailToolbarButtonType.PRIMARY}
            />
          )}
          {...generateNextProps}
          modes={[
            DetailMode.NONE,
            DetailMode.VIEW,
            DetailMode.EDIT,
            DetailMode.NEW,
          ]}
          dialogWidth={800}
          formInitialValues={
            { type: AuditingEntityType.AUDITOR } as GenerateLicenceDto
          }
        />
      )}
    </>
  );
}
